import { ProductWidgetStyles } from 'ggApp/shared/components/widgets/ProductWidget';

export const getContentfulWidgetContent = ({ homePageContent, position }) => {
    if (!homePageContent) {
        return null;
    }

    if (homePageContent[position]) {
        const fieldValidation =
            homePageContent[position].title &&
            homePageContent[position].description &&
            homePageContent[position].image?.url &&
            homePageContent[position].ctaLink &&
            homePageContent[position].ctaText;
        if (fieldValidation) {
            return homePageContent[position];
        }
    }

    return null;
};

export const extractProductWidgetData = (widgetList) => {
    if (!widgetList) {
        return {
            topProducts: {},
            newProducts: {},
            category1: {},
            category2: {},
            mostPopular: {},
            handpicked1: {},
            handpicked2: {},
            handpicked3: {},
            deals: {},
        };
    }
    const productWidgets = widgetList.filter((widget) => widget.type === 'productsWidget');
    const topProductsWidget = productWidgets.find(
        (widget) => widget.widget?.style === 'topProductsWidget',
    );
    const newProductsWidget = productWidgets.find((widget) =>
        widget.widget?.slug?.includes('new_products'),
    );
    const categoryWidgets = productWidgets.filter((widget) =>
        widget.widget?.slug?.includes('category'),
    );
    const mostPopularProducts = productWidgets.find((widget) =>
        widget.widget?.slug?.includes('top_ordered'),
    );
    const handpickedProductsWidgets = productWidgets.filter((widget) =>
        widget.widget?.slug?.includes('handpicked'),
    );
    const dealProductsWidget = productWidgets.find((widget) =>
        widget.widget?.slug?.includes('deal_products'),
    );
    return {
        topProducts: {
            products: topProductsWidget?.widget?.products ?? null,
            style: ProductWidgetStyles.topProducts,
        },
        newProducts: {
            products: newProductsWidget?.widget?.products ?? null,
            title: 'NEW_PRODUCTS_WIDGET_TITLE',
            cta: {
                url: '/trending?filter=sort%3Dnewest',
                label: 'NEW_PRODUCTS_WIDGET_CTA',
            },
            style: ProductWidgetStyles.productCarousel,
        },
        category1: {
            products: categoryWidgets[0]?.widget?.products ?? null,
            category: categoryWidgets[0]?.widget?.category ?? null,
            cta: {
                internal: true,
                url: categoryWidgets[0]?.widget?.category?.permalink ?? null,
                label: 'CATEGORY_WIDGET_CTA',
            },
            style: ProductWidgetStyles.category,
        },
        category2: {
            products: categoryWidgets[1]?.widget?.products ?? null,
            category: categoryWidgets[1]?.widget?.category ?? null,
            cta: {
                internal: true,
                url: categoryWidgets[1]?.widget?.category?.permalink ?? null,
                label: 'CATEGORY_WIDGET_CTA',
            },
            style: ProductWidgetStyles.category,
        },
        mostPopular: {
            products: mostPopularProducts?.widget?.products ?? null,
            title: 'POPULAR_PRODUCTS_WIDGET_TITLE',
            cta: {
                url: '/trending',
                label: 'POPULAR_PRODUCTS_WIDGET_CTA',
            },
            style: ProductWidgetStyles.productCarousel,
        },
        handpicked1: {
            products: handpickedProductsWidgets[0]?.widget?.products ?? null,
            style: ProductWidgetStyles.handpicked,
        },
        handpicked2: {
            products: handpickedProductsWidgets[1]?.widget?.products ?? null,
            style: ProductWidgetStyles.handpicked,
        },
        handpicked3: {
            products: handpickedProductsWidgets[2]?.widget?.products ?? null,
            style: ProductWidgetStyles.handpicked,
        },
        deals: {
            products: dealProductsWidget?.widget?.products ?? null,
            title: 'DEAL_PRODUCTS_WIDGET_TITLE',
            cta: {
                url: '/deals',
                label: 'DEAL_PRODUCTS_WIDGET_CTA',
            },
            style: ProductWidgetStyles.productCarousel,
        },
    };
};
